/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 10/27/20
 * Time: 4:06 PM
 */
import React, {Component} from 'react';
import success_icon from "../../../assets/img/sweet/success.svg";

class App extends Component {
  render() {
    return (
      <div className={"success-modal"}>
        <div className={"success-modal-img-wrapper"}>
          <img src={success_icon} alt={"."}/>
        </div>
        <p className={"first"}>
          We have received your request to join Visitor portal. Your request is currently under review and we will notify
          the status via email.</p>
        <p className={"second"}>Thank you!</p>
      </div>
    );
  }
}

export default App;
